// extracted by mini-css-extract-plugin
export default {"insightsTeamSummary":"pBLs9KeAnw8n00L61913"};